// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__KBhMf","choiceBoxes":"toolbarselects_choiceBoxes__x4-W6","simpleField":"toolbarselects_simpleField__3ZrRe"};